import { noneProfile } from "assets";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import SearchBar from "components/app/search-bar/SearchBar";

import { Loader, Plus, X } from "lucide-react";

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  isOpenDialogWorkflow: boolean;
  setIsOpenDialogWorkflow: (value: boolean) => void;
}
export default function DailogAddWorkflow({ isOpenDialogWorkflow, setIsOpenDialogWorkflow }: DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");

  return (
    <Dialog open={isOpenDialogWorkflow}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between max-w-[800px] h-[calc(100vh-80px)]">
        <DialogHeader>
          <DialogTitle>Custom workflow committees</DialogTitle>
          <DialogDescription>Assign Decision-Makers for Review and Authorization.</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setIsOpenDialogWorkflow(false);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <div className=" w-full gap-3 h-full overflow-y-auto">
          <div>
            <h4 className="text-xl font-semibold text-blue-600">Step Type</h4>
            <div className="grid  grid-cols-3 gap-2 mt-2">
              {["Check By", "Verify", "Review", "Inittail", "Approve By"].map((leave_type, index) => (
                <button key={index} className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold `}>
                  <p className="text-md font-semibold line-clamp-2 overflow-hidden">{leave_type}</p>
                </button>
              ))}
            </div>
          </div>
          <div className=" mt-5">
            <h4 className="text-xl font-semibold text-blue-600">Approve By</h4>
            <button className={`border outline-none px-4 bg-blue-500 text-white mt-2  py-1.5 rounded-lg text-sm font-semibold flex justify-between items-center`}>
              <p className="text-md font-semibold line-clamp-2 overflow-hidden pe-2">Select Employee</p>
              <Plus />
            </button>
          </div>
        </div>
        <DialogFooter>
          <button className={`w-full border outline-none px-4 bg-blue-500 text-white mt-2 py-2 rounded-lg text-sm font-semibold flex justify-center items-center`}>
            <p className="text-md font-semibold line-clamp-2 overflow-hidden ">Save workflow</p>
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
